import { Paper, Skeleton } from "@mantine/core";

export const SearchBarSkeleton = (): JSX.Element => (
    <Paper py="md">
        <Skeleton height="2.25rem" width="100%" radius="sm" />
    </Paper>
);
